'use client';

import {
  Searchbar,
  AssistedSaleSearchbar,
  ServicesSearchbar,
} from '@leroy-merlin-br/backpack-header';

import { useGlobalStore } from '@/presenters/store/global';
import {
  indexName,
  insightsConfig,
  productServicesIndexName,
  searchClient,
  retailMediaIndexName,
} from '@/utils/algolia';

interface SearchbarByContextProps {
  isAssistedSale: boolean;
  analyticsTags: string[];
}

export function SearchbarByContext(props: Readonly<SearchbarByContextProps>) {
  const { isAssistedSale, analyticsTags } = props;

  const session = useGlobalStore((state) => state.session);

  const shouldShowServicesSearchBar =
    session?.region === 'grande_sao_paulo' &&
    process.env.NEXT_PUBLIC_FEATURE_FLIP_SERVICES_SEARCHBAR_ENABLED === 'true';

  if (isAssistedSale) {
    return <AssistedSaleSearchbar />;
  }

  const algoliaConfig = {
    indexName,
    insightsClient: insightsConfig.insightsClient,
    searchClient,
    retailMediaIndexName,
    queries: [{ params: { analyticsTags }, indexName }],
  };

  if (shouldShowServicesSearchBar) {
    return (
      <ServicesSearchbar
        maxWidth="7xl"
        algolia={{
          ...algoliaConfig,
          productServicesIndexName,
        }}
      />
    );
  }

  return <Searchbar algolia={algoliaConfig} />;
}
